import { NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { MultiSelectModule } from 'primeng/multiselect';
import { Tag } from 'primeng/tag';
import BatteryStatus from '../../../../../../types/physical-sample/BatteryStatus';
import Sample from '../../../../../../types/sample/Sample';
import SelectOption from '../../../../../../types/shared/SelectOption';

@Component({
    selector: 'app-filter-physical-samples-dialog',
    templateUrl: './filter-physical-samples-dialog.component.html',
    styleUrls: [ './filter-physical-samples-dialog.component.scss' ],
    imports: [
        FormsModule,
        MultiSelectModule,
        DialogModule,
        ButtonModule,
        IftaLabelModule,
        Tag,
        NgForOf,
        NgIf,
    ]
})
export class FilterPhysicalSamplesDialogComponent implements OnChanges {
    @Input() visible: boolean = false;

    @Input() stateOptions: SelectOption[] = [];
    @Input() firmwareVersionOptions: SelectOption[] = [];
    @Input() ownerDealershipOptions: SelectOption[] = [];
    @Input() studioOptions: SelectOption[] = [];
    @Input() sampleOptions: Sample[] = [];

    @Input() activeFilters: {
        state: string[];
        firmwareVersions: string[];
        ownerDealershipIds: number[];
        studioIds: number[];
        sampleIds: number[];
        batteryStatuses: BatteryStatus[];
    } = {
        state: [],
        firmwareVersions: [],
        ownerDealershipIds: [],
        studioIds: [],
        sampleIds: [],
        batteryStatuses: [],
    };

    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() filtersApplied = new EventEmitter<any>();

    public batteryOptions = [
        { label: 'Full', value: BatteryStatus.FULL, icon: 'pi pi-align-justify', severity: 'success' },
        { label: 'High', value: BatteryStatus.HIGH, icon: 'pi pi-bars', severity: 'success' },
        { label: 'Medium', value: BatteryStatus.MEDIUM, icon: 'pi pi-equals', severity: 'info' },
        { label: 'Low', value: BatteryStatus.LOW, icon: 'pi pi-minus', severity: 'warn' },
        { label: 'Critical', value: BatteryStatus.CRITICAL, icon: 'pi pi-exclamation-triangle', severity: 'danger' },
        { label: 'Charging', value: BatteryStatus.CHARGING, icon: 'pi pi-bolt', severity: 'info' },
        { label: 'Unknown', value: BatteryStatus.UNKNOWN, icon: 'pi pi-question-circle', severity: 'secondary' },
    ];

    public filters = {
        state: [] as string[],
        firmwareVersions: [] as string[],
        ownerDealershipIds: [] as number[],
        studioIds: [] as number[],
        sampleIds: [] as number[],
        batteryStatuses: [] as BatteryStatus[],
    };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && this.visible) {
            this.filters = { ...this.activeFilters };
        }
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public resetFilters(): void {
        this.filters = {
            state: [],
            firmwareVersions: [],
            ownerDealershipIds: [],
            studioIds: [],
            sampleIds: [],
            batteryStatuses: [],
        };
        this.applyFilters();
    }

    public applyFilters(): void {
        this.filtersApplied.emit(this.filters);
        this.close();
    }
}
